// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"qLDbV","mainTitle":"hTFsx"};